import styled from "styled-components"
import { servicePageHeader } from "./servicePageHeader.css";

interface ServicePageHeaderStyledProps {
  rightHeroImage?: string,
  backgroundColor?: string,
  headerIcon?: string,
  textColor?: string
}

export const ServicePageHeaderStyled = styled.div<ServicePageHeaderStyledProps>`

  ${servicePageHeader}

  .right-hero-container {
    ${props => props.rightHeroImage
      ? `background-image: url(${props.rightHeroImage});`
      : `background-image: url(/img_contnet_writing_full.jpg);`
    }
  }

  /* @TODO - This double checks for backgroundColor presence as param, but it shouldn't. */
  ${props => props.backgroundColor
    ? `background-color: ${props.backgroundColor || "#FCEDBD"};`
    : `background-color: #FCEDBD;`
  }

  .service-page-header-icon {
    background-image: ${props => props.headerIcon
      ? `url('${props.headerIcon}')`
      : `url('ico_content_writing_2@2x.png')`
    };
  }

  .heading {
    color: ${props => props.textColor ? props.textColor : "black"};
  }

`